export const convertToLocaleCurrency = (
  input: number,
  currency: string = 'USD',
  digitsNumber: number = 2,
) => {
  const result = Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency,
    maximumFractionDigits: digitsNumber,
    minimumFractionDigits: digitsNumber,
    currencyDisplay: currency === 'USD' || currency === 'CAD' ? 'narrowSymbol' : 'symbol',
  }).format(input);
  return result;
};
